(function () {
  'use strict';

  function initFooter(footer) {
    if (!footer || footer.dataset.auraaFooterReady === 'true') return;
    footer.dataset.auraaFooterReady = 'true';

    var accordions = footer.querySelectorAll('[data-auraa-footer-accordion]');

    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function closePanel(item) {
      var toggle = item.querySelector('[data-auraa-footer-toggle]');
      var panel = item.querySelector('[data-auraa-footer-panel]');
      if (!toggle || !panel) return;
      toggle.setAttribute('aria-expanded', 'false');
      panel.classList.remove('is-open');
      panel.style.maxHeight = '0px';
    }

    function openPanel(item) {
      var toggle = item.querySelector('[data-auraa-footer-toggle]');
      var panel = item.querySelector('[data-auraa-footer-panel]');
      if (!toggle || !panel) return;
      toggle.setAttribute('aria-expanded', 'true');
      panel.classList.add('is-open');
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }

    accordions.forEach(function (item) {
      var toggle = item.querySelector('[data-auraa-footer-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        if (!isMobile()) return;
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        if (expanded) closePanel(item);
        else openPanel(item);
      });
    });

    function syncLayout() {
      accordions.forEach(function (item) {
        var panel = item.querySelector('[data-auraa-footer-panel]');
        var toggle = item.querySelector('[data-auraa-footer-toggle]');
        if (!panel || !toggle) return;
        if (isMobile()) {
          if (toggle.getAttribute('aria-expanded') === 'true') {
            panel.classList.add('is-open');
            panel.style.maxHeight = panel.scrollHeight + 'px';
          } else {
            panel.classList.remove('is-open');
            panel.style.maxHeight = '0px';
          }
        } else {
          panel.classList.remove('is-open');
          panel.style.maxHeight = '';
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    window.addEventListener('resize', syncLayout, { passive: true });
    syncLayout();
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-auraa-footer]').forEach(initFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();